import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
	disabled?: boolean;
	height?: number;
	width?: number;
}

export const TaxLetterIcon: React.FC<IProps> = ({
	className,
	fillColor = '#00AAE8',
	disabled,
	width = 18,
	height = 20,
}) => {
	return (
		<SvgIcon
			className={`tax-letter-icon ${className || ''}`}
			height={height}
			width={width}
			viewBox='0 0 18 20'
			style={{ opacity: disabled ? 0.5 : 1 }}
		>
			<g fill={fillColor} fillRule='evenodd'>
				{/* Document body */}
				<path d='M2 0C0.897 0 0 0.897 0 2v16c0 1.103 0.897 2 2 2h14c1.103 0 2-0.897 2-2V2c0-1.103-0.897-2-2-2H2zm0 2h14v16H2V2z' />
				{/* Dollar sign */}
				<path d='M10 5H8v1.05C6.86 6.283 6 7.292 6 8.5c0 1.378 1.122 2.5 2.5 2.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5H6v2h2v1h2v-0.95c1.14-0.233 2-1.242 2-2.55 0-1.378-1.122-2.5-2.5-2.5h-1C8.224 9 8 8.776 8 8.5S8.224 8 8.5 8H12V6h-2V5z' />
				{/* Bottom line */}
				<rect x='4' y='16' width='10' height='1.5' rx='0.75' />
			</g>
		</SvgIcon>
	);
};
